export var isImageFile = function (value) {
  return value !== null && value.hasOwnProperty('width') && value.hasOwnProperty('height');
};